import Vue from "vue";
import createAuth0Client from "@auth0/auth0-spa-js";
import axios from 'axios';
import * as Sentry from "@sentry/vue";
const DEFAULT_REDIRECT_CALLBACK = () =>
  window.history.replaceState({}, document.title, window.location.pathname);

let instance;

export const getInstance = () => instance;

export const useAuth0 = ({
  onRedirectCallback = DEFAULT_REDIRECT_CALLBACK,
  redirectUri = window.location.origin,
  ...options
}) => {
  if (instance) return instance;

  instance = new Vue({
    data() {
      return {
        loading: true,
        isAuthenticated: false,
        user: {},
        auth0Client: null,
        popupOpen: false,
        error: null,
        MemberInfo: {}
      };
    },
    methods: {
      getMemberInfo(email) {
        return axios({
          method: 'get',
          responseType: 'json',
          url: `https://devapi.ccr.net/production/cw_member_contact_view?$filter=Email_Address%20eq%20'${email}'`
        })
          .then(function (response) {

            return response.data.value[0];
          })
          .catch(function (error) {
            console.warn(`Error in getMemberInfo, cant find user by email:${email}`);
          });
      },
      async loginWithPopup(o) {
        this.popupOpen = true;

        try {
          await this.auth0Client.loginWithPopup(o);
          this.user = await this.auth0Client.getUser();
          this.isAuthenticated = await this.auth0Client.isAuthenticated();
          this.error = null;
        } catch (e) {
          console.error(e);
          this.error = e;
        } finally {
          this.popupOpen = false;
        }
      },
      async handleRedirectCallback() {
        this.loading = true;
        try {
          await this.auth0Client.handleRedirectCallback();
          this.user = await this.auth0Client.getUser();

          this.isAuthenticated = true;
          this.error = null;
        } catch (e) {
          this.error = e;
        } finally {
          this.loading = false;
        }
      },
      loginWithRedirect(o) {
        return this.auth0Client.loginWithRedirect(o);
      },
      getIdTokenClaims(o) {
        return this.auth0Client.getIdTokenClaims(o);
      },
      getTokenSilently(o) {
        return this.auth0Client.getTokenSilently(o);
      },
      getTokenWithPopup(o) {
        return this.auth0Client.getTokenWithPopup(o);
      },
      logout(o) {
        document.cookie = "auth0.is.authenticated=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
        document.cookie = "savedUser=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
        return this.auth0Client.logout(o);
      }
    },
    async created() {
      let savedUser = this.$cookies.get("savedUser")
      this.auth0Client = await createAuth0Client({
        domain: options.domain,
        client_id: options.clientId,
        audience: options.audience,
        redirect_uri: redirectUri
      });

      try {
        if (
          window.location.search.includes("code=") &&
          window.location.search.includes("state=")
        ) {
          const { appState } = await this.auth0Client.handleRedirectCallback();
          this.error = null;
          onRedirectCallback(appState);
        }
      } catch (e) {
        this.error = e;
      } finally {
        this.isAuthenticated = await this.auth0Client.isAuthenticated();

        //this.user = await this.auth0Client.getUser();
        let updatedUserDetails = await this.auth0Client.getIdTokenClaims()
        if (savedUser) {
          if (savedUser?.id_token == updatedUserDetails?.__raw.slice()) {
            this.logout({ returnTo: `${window.location.origin}` })
          } else {
            this.user.UserDetails = savedUser
            this.user.UserDetails.id_token =
               updatedUserDetails?.__raw.slice() ?? savedUser.id_token
            Vue.prototype.$axiosPlugin.addConfig({
              headers: {
                Authorization: `Bearer ${this.user.UserDetails.id_token}`
              }
            })
            if (
              this.user.UserDetails.Contact_Company_RecID !=
              this.user.UserDetails.Company_RecID
            ) {
              Vue.prototype.$axiosPlugin.setConfig({
                headers: {
                  Authorization: `Bearer ${this.user.UserDetails.id_token}`,
                  CompanyID: `${this.user.UserDetails.Company_RecID}`
                }
              })
            }
            this.$cookies.set('savedUser', this.user.UserDetails, '24h')
          }
        } else {
          this.user = updatedUserDetails;
          if (this.user) {
            this.user.UserDetails = this.user.nickname;
            this.user.UserDetails.email = this.user.email;
            this.user.nickname = "";
            this.user.UserDetails.id_token = this.user.__raw.slice();
            Sentry.setUser({
              email: this.user.email,
              Company_Name: this.user.UserDetails.Company_Name,
              Company_RecID: this.user.UserDetails.Company_RecID,
              Contact_RecID: this.user.UserDetails.Contact_RecID
            });
            Vue.prototype.$axiosPlugin.addConfig({
              headers: {
                Authorization: `Bearer ${this.user.__raw}`,
              }
            })
            if (this.user.UserDetails.Contact_Company_RecID != this.user.UserDetails.Company_RecID) {
              Vue.prototype.$axiosPlugin.setConfig({
                headers: {
                  Authorization: `Bearer ${this.user.__raw}`,
                  CompanyID: `${this.user.UserDetails.Company_RecID}`
                }
              })
            }

          }
        }
        this.loading = false;
      }
    }
  });

  return instance;
};

export const Auth0Plugin = {
  install(Vue, options) {
    Vue.prototype.$auth = useAuth0(options);
  }
};
